// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap-css-only/css/bootstrap.min.css';
import '../build/css/mdb.css';
import Vue from 'vue';
import App from './App';
import th from 'vee-validate/dist/locale/th';
import VeeValidate, { Validator } from 'vee-validate';
import router from './router';
import AlertPlug from './components/pro/AlertPlug.js';
import Style from '../build/css/style.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSailsIO from 'vue-sails.io';
import config from './config';
import ReadMore from 'vue-read-more';
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'videojs-hls-quality-selector/dist/videojs-hls-quality-selector.css';
import 'vue-video-player/src/custom-theme.css';
import 'videojs-flash';
import moment from 'moment';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import JwPagination from 'jw-vue-pagination';

Vue.use(VueVideoPlayer);
Vue.use(VueAwesomeSwiper);
Vue.use(ReadMore);
Vue.use(VueSailsIO, config.app.Host);
Vue.use(VeeValidate);
Vue.use(VueAxios, axios);
Vue.use(AlertPlug);
Vue.config.productionTip = false;
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY');
  }
});
Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY HH:mm');
  }
});
Vue.component('jw-pagination', JwPagination);

Validator.localize('th', th);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  Style,
  router,
  template: '<App/>',
  components: { App }
}).$mount('#app');
